/* eslint-disable no-param-reassign */

import Field from '.';
import { getFormAutoEditorConversions } from '../FormAutoEditor/convertUtils';
import FieldPropPanel from "./FieldPropPanel";

/** @type {UICore.ComponentMeta} */
const FieldComponentMeta = {
  id: 'w-field',
  name: '数据字段',
  component: Field,
  bindings: [{
    id: '数据源',
    pathProp: 'path'
  }],
  slots: [{
    id: 'default',
    containerRef: 'editorArea'
  }],
  propsSchema: {
    type: 'object',
    fields: [{
      id: 'path',
      type: 'string',
      title: '数据路径',
      readonly: true,
      description: '请通过“连连看”的方式添加绑定'
    }, {
      id: 'readonly',
      type: 'boolean',
      default: false
    }, {
      id: 'fillLine',
      title: '撑满整行',
      type: 'boolean',
      default: false
    }, {
      id: 'hideLabel',
      type: 'boolean',
      default: false
    }, {
      id: 'useCustomInput',
      type: 'boolean',
      title: '使用自定义编辑框组件',
      default: false
    }, {
      id: 'uiSettings',
      type: 'any',
      default: null
    }, {
      id: 'labelText',
      type: 'string',
      default: ''
    }, {
      id: 'tooltipText',
      type: 'string',
      default: ''
    }, {
      id: 'description',
      type: 'string',
      default: ''
    }]
  },
  propPanel: {
    main: FieldPropPanel
  },
  getActions: getFormAutoEditorConversions
};
export default FieldComponentMeta;
//# sourceMappingURL=meta.js.map
